import { useEffect } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { gtm } from '../../../lib/gtm';
import { AdminCreateForm } from '../../../components/dashboard/create/create-admin';

const CreateAdmin = () => {

  useEffect(() => {
      gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Box
        component="main"
        sx={{
        flexGrow: 1,
        py: 11
        }}
      >
        <Container maxWidth="x1">
          <Box sx={{ mb: 5 }}>
            <Grid
            container
            justifyContent="space-between"
            spacing={3}
            >
              <Grid item>
                <Typography variant="h4" sx={{fontFamily: "Montserrat"}}>
                Créer un admin
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <AdminCreateForm/>
        </Container>
      </Box>
    </>
  );
};

export default CreateAdmin;
